import { render, staticRenderFns } from "./BlockConfirm.vue?vue&type=template&id=2712b4f4"
import script from "./BlockConfirm.vue?vue&type=script&lang=js"
export * from "./BlockConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports